"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DefaultLabels = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable max-len */

/*
  How do the different definitions work?
  ----------------------------------------

  parentField:        keys within the productDefinition to look in for values
  valueType:          how it will render on the screen
  valueMap:           if it finds a match with one of the parentField it will then use this to determine the
                      actual value to display.
  formatter:         a custom function used by certain value types (e.g. customFormat)
                      to format the value for display on the screen
  defaultValueIndex:  for items that have an array of options it is the index
                      of the default selected item

  In this example;
  ----------------------------------------
  excess: {
    parentField: ['excessOptions', 'upmExcesses', 'upmExcessOptions'],
    defaultValueIndex: 0
  }

  defaultValueIndex: Indicates that the first excess option is selected by default

  Optional properties:
  valueMap: { // For Radios
    label - This is the object property that will be used as the label of each radio item
    value - This is the object property that will be used as the value of each radio item
  }

  dynamicVariant: Displays as radio options in a merged plans view
  dynamicVariantValue: Checks across the group of plans and if the value varies makes radio options

  formatters: {
    label - Primarily used to format the labels of radios
    value - Primarily used to format the value of radios
    displayValue - Primarily used to format static values
  }
*/

var DefaultLabels = exports.DefaultLabels = {
  excess: {
    label: 'Excess (per condition)',
    tooltip: 'The excess is applied on a \'per condition, per policy period\' basis when you claim. Please note the higher the excess you select, the lower your premium will be, but this means you will need to cover higher out of pocket costs at claim time. Refer to the PDS for claims examples.',
    parentField: 'upmExcessOptions',
    defaultValueIndex: 0,
    formatters: {
      label: function label(value) {
        return "$".concat(parseInt(value, 10));
      }
    }
  },
  routineCare: {
    label: 'Add Routine Care',
    subLabel: '(Non-insurance benefit) - coverage for items such as annual check-ups and vaccinations',
    tooltip: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Routine Care is an optional non-insurance benefit which allows you to claim a total of $150 per policy period. It is made up of three $50 benefits, which applies to the following items:", /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Desexing"), /*#__PURE__*/_react["default"].createElement("li", null, "Vaccinations or health checks"), /*#__PURE__*/_react["default"].createElement("li", null, "Microchipping"), /*#__PURE__*/_react["default"].createElement("li", null, "Heartworm preventative"), /*#__PURE__*/_react["default"].createElement("li", null, "Dew claw removal"), /*#__PURE__*/_react["default"].createElement("li", null, "Prescription diets"), /*#__PURE__*/_react["default"].createElement("li", null, "Teeth cleaning"), /*#__PURE__*/_react["default"].createElement("li", null, "Cremation/burial"), /*#__PURE__*/_react["default"].createElement("li", null, "Council registration fees"), /*#__PURE__*/_react["default"].createElement("li", null, "Alternative medication"), /*#__PURE__*/_react["default"].createElement("li", null, "Obedience training"), /*#__PURE__*/_react["default"].createElement("li", null, "Heartworm tests or blood screen"), /*#__PURE__*/_react["default"].createElement("li", null, "FeLv/FIV tests or urinalysis"), /*#__PURE__*/_react["default"].createElement("li", null, "Flea/tick/worm control"))),
    valueType: 'yesNoBoolean',
    dynamicVariant: true,
    dynamicVariantValue: 'routineCare',
    // TODO: Benefit limit should be fetched from the actual plan file and should use formatter to display value.
    benefitLimit: '$150 limit'
  },
  dental: {
    label: 'Add Booster Care',
    subLabel: 'Coverage for specified dental conditions like gingivitis and specialised therapies like physio and behavioural therapies',
    tooltip: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Booster Care is an optional benefit available to select in addition to your annual benefit limit."), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Specified dental conditions")), /*#__PURE__*/_react["default"].createElement("p", null, "Treatment for the following specified dental conditions: gingivitis; abscesses; or removal of teeth where medically necessary due to dental disease arising from infection; retained deciduous teeth; cavities; or fractured teeth."), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Specialised therapies")), /*#__PURE__*/_react["default"].createElement("p", null, "Specialised therapies means any examination, test and legally prescribed medication for the following procedures where they treat an eligible condition. This includes any treatment specifically needed and recommended by your vet, limited to: Physiotherapy or physical therapy, Chiropractic Manipulation, Hydrotherapy, Acupuncture and treatment or consultation for behavioural conditions.")),
    valueType: 'yesNoBoolean',
    dynamicVariant: true,
    dynamicVariantValue: 'dental',
    // TODO: Benefit limit should be fetched from the actual plan file and should use formatter to display value.
    benefitLimit: '$2,000 limit'
  },
  ageLimits: {
    label: 'Age Limit',
    valueType: 'limit'
  },
  levelOfCover: {
    label: 'Benefit percentage',
    formatters: {
      label: function label(value) {
        return "".concat(value, "%");
      },
      displayValue: function displayValue(value) {
        return "".concat(value, "%");
      }
    },
    tooltip: 'This is the portion we cover for eligible vet expenses or items, subject to policy limits and excess. Note: The benefit percentage does not apply to non-insurance routine care items. Refer to PDS for claims examples.'
  },
  annualLimit: {
    label: 'Annual benefit limit',
    tooltip: 'This is the maximum amount you can claim for per policy period, subject to any applicable sub-limits and excess. The limit resets to the full amount each time you renew. Refer to the PDS for claims examples.',
    valueType: 'limit'
  },
  accidentalInjury: {
    label: 'Specified accidental injury',
    tooltip: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Specified accidental injury means physical harm or injury of at least one of the following:", /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "a motor vehicle incident;"), /*#__PURE__*/_react["default"].createElement("li", null, "a burn or electrocution;"), /*#__PURE__*/_react["default"].createElement("li", null, "a reaction to a bite from an insect, spider or scorpion;"), /*#__PURE__*/_react["default"].createElement("li", null, "a near drowning incident;")), "OR", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), "the specified accidental injury must be one of the following:", /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "a bone fracture;"), /*#__PURE__*/_react["default"].createElement("li", null, "a traumatic tooth fracture;"), /*#__PURE__*/_react["default"].createElement("li", null, "snake bite toxicity;"), /*#__PURE__*/_react["default"].createElement("li", null, "ingestion of a foreign object;"), /*#__PURE__*/_react["default"].createElement("li", null, "poisoning;"), /*#__PURE__*/_react["default"].createElement("li", null, "a traumatic ligament or tendon injury;"), /*#__PURE__*/_react["default"].createElement("li", null, "a bite wound or fight wound abscesses;"), /*#__PURE__*/_react["default"].createElement("li", null, "lacerations or abrasion of tissue, skin or mucous membrane due to external trauma; or"), /*#__PURE__*/_react["default"].createElement("li", null, "a cruciate ligament condition (subject to a waiting period, see the \u201CWaiting periods\u201D section for more information).")))
  },
  coversIllness: {
    label: 'Illnesses',
    tooltip: 'Illness means a sickness or a disease that is not included under specified accidental injury cover or is not a specified dental condition or behavioural condition. Examples include (but not limited to) skin conditions and cancer treatment'
  },
  tickParalysis: {
    label: 'Tick paralysis',
    valueType: 'limit',
    valueMap: {
      value: 'tickParalysis'
    }
  },
  emergencyBoarding: {
    label: 'Emergency boarding ',
    valueType: 'limit',
    valueMap: {
      value: 'emergencyBoardingLimit'
    },
    shortLabel: 'Emergency Boarding',
    tooltip: "If you are hospitalised for one or more consecutive days during the policy period and/or you require emergency accommodation due to family violence, we will cover the benefit percentage for your pet\u2019s boarding costs incurred by you at a licensed kennel or cattery, subject to the sub-limit (if any) shown on your certificate of insurance and the annual benefit limit. See PDS for further information."
  },
  consultation: {
    label: 'Consultations',
    tooltip: 'Consultation means an examination performed by or under the supervision of a vet for eligible conditions. You are covered up to the applicable annual sub-limit (if any) and annual benefit limit. This limit does not apply to additional benefit limits (if applicable). For further information refer to the PDS.',
    valueMap: {
      value: 'consultationLimit'
    },
    valueType: 'limit'
  },
  cruciateLigament: {
    label: 'Cruciate ligament conditions',
    valueType: 'limit'
  },
  hipJoints: {
    label: 'Hip joint surgery',
    subLabel: '(Total Hip replacements included)',
    valueMap: {
      value: 'hipJointRightHip'
    },
    valueType: 'limit'
  },
  waitingPeriods: {
    label: 'Waiting periods',
    valueType: 'custom_waitingPeriods',
    tooltip: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Waiting period means the period that your pet is not covered, and starts from the commencement date of the first policy period.", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), " If a condition exists or occurs during the waiting period, it will be considered a pre-existing condition and may be excluded from cover.", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), " Some pre-existing conditions are eligible for review after an 18-month period \u2013 for more information on waiting periods and pre-existing conditions, refer to your PDS."),
    customValue: [{
      id: 'Specified_accidental_injuries',
      messages: [{
        condition: 'Specified accidental injuries',
        waitingPeriod: '0 days'
      }]
    }, {
      id: 'Illness',
      messages: [{
        condition: 'Illness',
        waitingPeriod: '30 days'
      }]
    }, {
      id: 'Cruciate_ligament_conditions',
      messages: [{
        condition: 'Cruciate ligament conditions',
        waitingPeriod: '6 months'
      }]
    }, {
      id: 'Booster_Care',
      title: 'Booster Care (where selected):',
      messages: [{
        condition: 'Specialised therapies',
        waitingPeriod: '30 days'
      }, {
        condition: 'Specified dental conditions',
        waitingPeriod: '6 months'
      }]
    }]
  },
  preExistingCondition: {
    label: 'Pre-existing conditions',
    tooltip: 'Pre-existing condition means a condition that first existed or occurred prior to the commencement date of your first policy period or within any applicable waiting period AND which you were aware of, or a reasonable person in your circumstances would have been aware, irrespective of whether the underlying or causative condition has been diagnosed. Please refer to your PDS for more information.',
    valueNote: 'Certain pre-existing conditions are eligible for a review after 18 months.'
  },
  gapOnly: {
    label: "GapOnly\xAE"
  },
  cancerTreatment: {
    label: 'Cancer treatment'
  },
  skinConditions: {
    label: 'Skin Conditions'
  },
  medicinesDrugs: {
    label: 'Prescription medicines & drugs',
    tooltip: 'These are examples of treatments provided by a vet to relieve or cure a condition covered under your policy (subject to policy terms and conditions). Refer to your PDS for more information.'
  },
  hospitalisation: {
    label: 'Hospitalisation, surgery and specialist care',
    tooltip: 'These are examples of treatments provided by a vet to relieve or cure a condition covered under your policy (subject to policy terms and conditions). Refer to your PDS for more information.'
  },
  specialistCare: {
    label: 'Diagnostic tests and radiology',
    tooltip: 'These are procedures provided in relation to conditions covered by your policy (subject to policy terms and conditions). Refer to your PDS for more information.'
  },
  labAndDiagnosticTests: {
    label: 'Lab & diagnostic tests',
    footnote: true
  },
  radiology: {
    label: 'Radiology',
    footnote: true
  },
  surgery: {
    label: 'Surgery',
    footnote: true
  },
  hereditary: {
    label: 'Hereditary & congenital conditions',
    tooltip: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Hereditary and congenital conditions may be covered, unless considered a pre-existing condition. Subject to policy T&Cs, limits, exclusions, waiting periods and excess (if any). Refer to your PDS for more information.")
  }
};
var _default = exports["default"] = {
  DefaultLabels: DefaultLabels
};